// src/pages/ContactPage.jsx
import { Link } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';
import Layout, { useLanguage } from '../components/Layout';

export default function ContactPage() {
  const { t } = useLanguage();

  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>{t('contact.title') || 'Contact Us'}</h1>
          <p className="page-subtitle">
            {t('contact.subtitle') || 'Get in touch with our team'}
          </p>

          <div className="contact-page-grid">
            <div className="contact-info-card">
              <h2>{t('contact.getInTouch') || 'Get in Touch'}</h2>
              <div className="contact-detail">
                <FaPhone className="contact-detail-icon" />
                <div>
                  <strong>{t('contact.phone') || 'Phone'}</strong>
                  <p><a href="tel:0730320000">0730 320 000</a></p>
                </div>
              </div>
              <div className="contact-detail">
                <FaWhatsapp className="contact-detail-icon" />
                <div>
                  <strong>WhatsApp</strong>
                  <p><a href="https://wa.me/254111636443">+254 111 636443</a></p>
                </div>
              </div>
              <div className="contact-detail">
                <FaEnvelope className="contact-detail-icon" />
                <div>
                  <strong>{t('contact.email') || 'Email'}</strong>
                  <p><a href="mailto:hello@nexcom.ke">hello@nexcom.ke</a></p>
                </div>
              </div>
              <div className="contact-detail">
                <FaMapMarkerAlt className="contact-detail-icon" />
                <div>
                  <strong>{t('contact.location') || 'Location'}</strong>
                  <p>{t('contact.locationValue') || 'Kisumu, Kenya'}</p>
                </div>
              </div>
              <div className="contact-detail">
                <FaClock className="contact-detail-icon" />
                <div>
                  <strong>{t('contact.hours') || 'Hours'}</strong>
                  <p>{t('contact.monFri') || 'Mon-Fri: 8AM - 6PM'}</p>
                  <p>{t('contact.sat') || 'Sat: 9AM - 2PM'}</p>
                </div>
              </div>
              <div className="social-links-page">
                <a href="https://www.facebook.com/NexcomKe" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                <a href="https://twitter.com/NexcomKe?s=20" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                <a href="https://instagram.com/NexcomKe" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                <a href="https://api.whatsapp.com/send?phone=254730320320" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
              </div>
            </div>

            <div className="contact-form-card">
              <h2>{t('contact.sendMessage') || 'Send a Message'}</h2>
              <form className="contact-form-page">
                <input 
                  type="text" 
                  placeholder={t('contact.form.name') || 'Full Name *'} 
                  required 
                />
                <input 
                  type="email" 
                  placeholder={t('contact.form.email') || 'Email Address'} 
                />
                <input 
                  type="tel" 
                  placeholder={t('contact.form.phone') || 'Phone Number *'} 
                  required 
                />
                <select required>
                  <option value="">{t('contact.form.selectService') || 'Select Service'}</option>
                  <option value="internet">{t('nav.internet') || 'Internet'}</option>
                  <option value="wifi">{t('nav.wifi') || 'WiFi'}</option>
                  <option value="equipment">{t('contact.form.equipment') || 'Equipment'}</option>
                  <option value="support">{t('footer.support') || 'Support'}</option>
                </select>
                <textarea 
                  placeholder={t('contact.form.message') || 'Your Message'} 
                  rows="5" 
                  required
                ></textarea>
                <button type="submit" className="contact-submit-btn">
                  <FaEnvelope /> {t('contact.form.send') || 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}